import React, { useContext } from 'react';
import { useQuery } from 'react-query';
import { getPageType } from 'cms/parsers';
import SiteContext from 'site/SiteContext';
import styled from 'styled-components';
import DefaultPage from './content_types/DefaultPage';
import { buildCrumbs } from 'helpers/breadcrumb';
import BreadCrumbWithRouter from 'components/organisms/BreadCrumbWithRouter';

import { buildJourneylineHeader } from 'helpers/journeylineheader';

import { Loading } from 'dma-ui-kit';
import PageNotFoundPage from '../PageNotFound';

import createAxiosInstance from 'helpers/axios';
const axiosInstance = createAxiosInstance();

const appEnv = process.env.REACT_APP_ENV;
const baseEndpoint = process.env.REACT_APP_CMS_BASE_PATH;

const NoBreadCrumb = styled.div`
    margin-bottom: 20px;
`;

/**
 * Renders a page manifest that has already been loaded. Shared by the
 * published-page route (DrupalPage) and the CMS preview route (PreviewPage).
 *
 * `data` is the manifest document ({ data: { type, attributes, relationships } }),
 * `pathname` is the site path used to build breadcrumbs.
 */
export const DrupalPageContent = ({ data, pathname, error }) => {

    const breadCrumbs = buildCrumbs(pathname);

    if (data && data.data) {

        if (data.data.attributes?.field_patron_roles && data.data.attributes.field_patron_roles.length > 0) {
            // The page is restricted to a Patron role - render the PageNotFoundPage for unauthorized users
            return <PageNotFoundPage />;
        }

        const pageManifest = data.data;
        const PageType = getPageType(data);

        return (
            <div>
                {buildJourneylineHeader(pageManifest)}
                { breadCrumbs.length > 0 ? 
                    <BreadCrumbWithRouter breadcrumbs={breadCrumbs} /> : 
                    <NoBreadCrumb /> 
                }
                { error ? 
                    <DefaultPage /> :
                    <PageType pageManifest={pageManifest} />
                }
            </div>
        );
    }

    return <PageNotFoundPage />;
};

const DrupalPage = (props) => {

    const { location } = props;
    const { languagePath, siteData } = useContext(SiteContext);

    if (!location) return <></>;

    const pathName = (location.pathname == "/") ? siteData.front : location.pathname;
    const endpoint = `${baseEndpoint}${appEnv}/content${languagePath}${pathName}.json`;
    
    const { isLoading, error, data } = useQuery(['drupalPage', endpoint], async () => 
        await axiosInstance.get(endpoint)
    );

    if (isLoading) return <Loading />;

    return <DrupalPageContent data={data} pathname={location.pathname} error={error} />;
};

export default DrupalPage;
